import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil} from "rxjs/operators";
import { Category } from '../../../../../shared/interfaces/category';
import { ConsoleLoggerService } from '../../../../../core/services/console-logger.service';
import { FirestoreService } from '../../../../../shared/services/firestore.service';
import { nav_path } from '../../../../../app-routing.module';

@Component({
  selector: 'anon-edit-category',
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.scss']
})
export class EditCategoryComponent implements OnDestroy {
  private unsub$: Subject<any> = new Subject<any>();
  category!: Category;
  error: any;
  editCategoryForm = new FormGroup({
    name: new FormControl('', Validators.required),
    description: new FormControl(''),
    slug: new FormControl('', Validators.required),
    image: new FormControl(''),
    featured: new FormControl(false),
  });

  constructor(
    private route: ActivatedRoute,
    private db: FirestoreService,
    private router: Router,
    private cLog: ConsoleLoggerService
  ) {
    this.route.params.pipe(takeUntil(this.unsub$))
      .subscribe(routeParams => {
        const category_slug = routeParams['category_slug'];
        this.db.doc$(`categories/${category_slug}`)
          .pipe(takeUntil(this.unsub$))
          .subscribe(
            (category: any) => {
              if (category?.name && category?.slug) this.setCategory(category);
              else this.error = {message: `Category not found: ${category_slug}`};
            },
            error => this.cLog.error('error getting category', error),
          )
      });
  }
  get name() { return this.editCategoryForm.get('name'); }
  get description() { return this.editCategoryForm.get('description'); }
  get slug() { return this.editCategoryForm.get('slug'); }
  get featured() { return this.editCategoryForm.get('featured'); }

  setCategory(category: Category) {
    this.category = category;
    this.editCategoryForm = new FormGroup({
      name: new UntypedFormControl(category.name, Validators.required),
      description: new UntypedFormControl(category.description),
      slug: new UntypedFormControl(category.slug, Validators.required),
      image: new UntypedFormControl(category.image),
      featured: new UntypedFormControl(category.featured)
    });
    this.slug?.disable();
  }

  saveCategory() {
    this.slug?.enable();
    const category = this.editCategoryForm?.value;
    if (
      this.category.name != category.name
      || this.category.description != category.description
      || this.category.featured != category.featured
    ) {
      this.db.update(`categories/${this.category.slug}`, category)
        .then(() => {
          this.cLog.info(`successfully updated category: '${this.category.slug}'`);
          this.router.navigate([nav_path.adminCategories]);
        });
    }
  }

  public deleteCategory() {
    this.db.delete(`categories/${this.category.slug}`)
      .then(() => {
        this.cLog.info(`successfully deleted category: '${this.category.slug}'`)
        this.router.navigate([nav_path.adminCategories]);
      });
  }

  ngOnDestroy() { this.unsub$.next(undefined); this.unsub$.complete(); }
}
